import { createApp } from 'vue/dist/vue.esm-bundler';
import AgendaItem from './components/AgendaItem.vue';
import Skeleton from './components/Skeleton.vue';
import mixin from '../mixin.js';
import axios from 'axios';

const agendaItemApp = {
    components: { AgendaItem, Skeleton },
    mixins: [mixin],
    data() {
        return {
            dataApi: '',
            dataEventId: '',

            loading: true,
            item: null,
            blockView: false
        }
    },
    methods: {
        fetchData() {
            let tempQueryModel = {
                FilterItems: [{
                    Key: 'id',
                    Values: [this.dataEventId],
                    Operator: 'Eq',
                }]
            };

            axios
                .post(this.dataApi, tempQueryModel)
                .then(response => {
                    if (response.status === 200) {
                        if (response.data.items.length) {
                            this.item = response.data.items[0];
                        }
                    }
                })
                .catch(error => console.log(error))
                .finally(() => this.loading = false);
        },
        redirect(url) {
            if (url) window.location.href = url;
        },
        toMediaQuery(mediaString) {
            if (!mediaString) return '';
            return mediaString.split('"')[1];
        },
        reverse(array) {
            return [...array].reverse();
        }
    },
    mounted() {
        if (this.$el.dataset.api) this.dataApi = this.$el.dataset.api;
        if (this.$el.dataset.eventid) this.dataEventId = this.$el.dataset.eventid;

        this.fetchData();
    },
};

export default agendaItemApp;


